import { ICurrency } from 'core/model/interfaces/currency.interface';

export const DEFAULT_CURRENCY: ICurrency = {
  symbol: 'S/',
  id: 'PEN',
};
